import Modal from 'LuxKit/Modal/Modal'
import styled from 'styled-components'
import { rem } from 'polished'
import BodyText from 'LuxKit/Typography/BodyText'
import { INTL_PICKER_DATE_FORMAT } from 'constants/dateFormats'
import { useIntlDateFormatter } from 'lib/datetime/dateUtils'
import HelpPane from 'components/Common/HelpPane'
import { useIntl } from 'react-intl'

const ModalContent = styled.div`
  padding-top: ${rem(16)};
`

interface Props {
  refundable: boolean
  startDate?: moment.Moment
  cancellationPolicyDetail: string
  nonAmendableTitle?: string
}

function AlwaysOnOfferPropertyCancellationPolicyModal(props: Props) {
  const {
    refundable,
    cancellationPolicyDetail,
    startDate,
    nonAmendableTitle,
  } = props

  const intl = useIntl()
  const intlDateFormatter = useIntlDateFormatter()

  const modalTitle = refundable
    ? intl.formatMessage({
        id: 'erR4g37tir7fnKc4AuZL',
        defaultMessage: 'Free cancellation',
        description: 'Title for free cancellation modal in the cancellation or refund flow',
      })
    : nonAmendableTitle ?? intl.formatMessage({
      id: 'IAJAGGueui7nqK698huB',
      defaultMessage: 'Non refundable',
      description: 'Title for non-refundable cancellation modal in the cancellation flow',
    })

  return <Modal
    title={modalTitle}
  >
    <ModalContent>
      {(!startDate || !refundable) && (
        <BodyText variant="large" as="p">{cancellationPolicyDetail}</BodyText>
      )}
      {refundable && startDate && (
        <BodyText variant="large" as="p">
          {intl.formatMessage(
            {
              id: 'JHETZPo1bnGMogTFxH5U',
              defaultMessage: 'Standard bookings can be cancelled with a full refund provided the cancellation made by {date} 11:59 PM (local time of property).',
              description: 'Description of free cancellation policy with date in a modal dialog',
            },
            {
              date: intlDateFormatter(startDate, INTL_PICKER_DATE_FORMAT),
            },
          )}
        </BodyText>
      )}
      <HelpPane />
    </ModalContent>
  </Modal>
}

export default AlwaysOnOfferPropertyCancellationPolicyModal
